export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4803.a166cdfd.jpg";